import React from 'react'
import {Column, Row} from "simple-flexbox";
import {Button } from "@material-ui/core";
import CustomInput from "../../common/components/CustomInput";
import {history} from "../../managers/history";
// import {makeStyles} from '@material-ui/core/styles'
// import Box from '@material-ui/core/Box'




function Resetform(props) {
    let {state, onChangeEvent, onResetClicked} = props;
    return (
        
        <Column className="resetform w-520 pt-5  align-items-center mt-5 h-430" horizontal={'center'} >
             <img src="/RealsNFT.svg" alt='Logo' className="w-120"/>
            <form onSubmit={(event) => onResetClicked(event)} className="w-100 form p-3">
                <Row className="justify-content-center w-100 fs-16 fc-1f1f1f h-22">
                    Reset your password here
                </Row>

                <div className="fc-dark-slate-blue fs-16 mt-3 resetemail w-48">Email:</div>
                <CustomInput id="email" type="text" value={state ? state.email : ""} onChange={onChangeEvent}
                             error={state ? state.emailError : ""} className="fs-16 p-2 mt-1 h-55 bg-eee" required={true}/>
                        <span className='fc-red'>{state.newEmailError}</span>
              

                <Button type='submit' className="bg-blue outline-none text-transform-capitalize font-weight-bold
                fc-white w-100 py-2 fs-16  my-3 cursor-pointer resetbtn h-63 t-45">
                  <span class="font-weight-bold">Reset Password</span>
                </Button>
                <div className="fc-d5d5d5 fs-16 mt-45 text-center">Return to <a href="" className="fc-5386f8 fs-16" onClick={props.routeChange}>Sign In</a></div>
            </form>
        </Column>
        
    );
}

function HeaderComponent(props) {
    return (
        <Row vertical="center" className="justify-content-between">
           
            <Row vertical="center">
                {/* <Column vertical="center" className="fc-brownish-grey fs-15 px-2 py-1">New user?</Column> */}
                {/* <Column vertical="center" className="fc-blue br-4 b-1-blue fs-17 px-2 py-1 cursor-pointer"
                        onClick={() => history.replace("/sign-up")}>
                    Sign Up
                </Column> */}
            </Row>
        </Row>
    )
}

function ResetComponent(props) {
    return (
        <Column horizontal={'center'} className="w-100 p-3 min-vh-100 h-100 justify-content-between">
            <Column className="w-100">
                {HeaderComponent(props)}
                <Row horizontal="center" className="resetStyle w-100 my-5">
                    {Resetform(props)}
                </Row>
            </Column>
            <Column className="jc-center w-100 align-items-left fs-14 my-3">
               
                
            </Column>
        </Column>
    );
}

export default ResetComponent;